import { Directive, ElementRef, HostBinding, Input, OnInit, OnChanges, Renderer2, SimpleChanges } from "@angular/core";
import { GridWidth } from "@spscommerce/ds-shared";

@Directive({ selector: "[spsGridWidth]" })
export class SpsGridWidthDirective implements OnInit, OnChanges {
    @Input() spsGridWidth: GridWidth;

    @HostBinding("class.d-none") get zeroWidth() {
        return this.spsGridWidth === 0;
    }

    constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

    ngOnInit() {
        this.renderer.addClass(this.elementRef.nativeElement, `col-${this.spsGridWidth}`);
    }

    ngOnChanges(changes: SimpleChanges) {
        this.renderer.removeClass(this.elementRef.nativeElement, `col-${changes.spsGridWidth.previousValue}`);
        this.renderer.addClass(this.elementRef.nativeElement, `col-${changes.spsGridWidth.currentValue}`);
    }
}
